import {json} from '../../../core/data-source/json.mapper';
import {getStrings} from '../../../core/lang';
import accontSettingsVariantsStrings from './account-settings-variants.strings.yaml';
export enum DataType {
    FLOAT = 'FLOAT',
    INTEGER = 'INTEGER',
    BOOLEAN = 'BOOLEAN',
    BOOLEAN_RELATED = 'BOOLEAN_RELATED',
    TIME = 'TIME',
    PERIOD_FIELD = 'PERIOD_FIELD',
    PERIOD_FIELD_WITH_MS = 'PERIOD_FIELD_WITH_MS',
    RADIO = 'RADIO',
    TEXT = 'TEXT',
    PASSWORD = 'PASSWORD',
    LIST = 'LIST',
    MULTISELECT_LIST = 'MULTISELECT_LIST',
    TEST_BUTTON = 'TEST_BUTTON',
    NOTICE = 'NOTICE',
    TIME_INTERVAL = 'TIME_INTERVAL',
    LONGTEXT = 'LONGTEXT',
    HIDDEN_LIST = 'HIDDEN_LIST'
}

const RELATIONS = {
    updateLandmarkOnArrivalRadio: 'updateLandmarkOnArrivalCheckbox',
    onBoardTimeLimitCollection: 'activeOnBoardTimeLimitCollection',
    onBoardTimeLimit: 'activeOnBoardTimeLimit',
    timeSendOrderDetailsByTimer: 'enableSendOrderDetailsByTimer',
    'capacity.units': 'enableCapacityConstraint',
    'capacity.decimalPrecision': 'enableCapacityConstraint',
    'capacity.label': 'enableCapacityConstraint',
    volumeUnits: 'enableVolumeConstraint',
    volumeLabel: 'enableVolumeConstraint',
    'volume.decimalPrecision': 'enableVolumeConstraint'
};

const S = getStrings(accontSettingsVariantsStrings);
export class AccountSettingsRecord {
    @json({
        skip: true,
        value: false
    })
    mandatory: boolean;

    @json()
    name: string;

    @json({
        skip: true,
        mapper: {
            from: (value: string, record: any): DataType => {
                if (
                    record.name === 'hiddenItemFieldsForDriver' ||
                    record.name === 'mandatoryFieldsForDriverOrderItems' ||
                    record.name === 'orderItemTypeValues'
                ) {
                    return DataType.HIDDEN_LIST;
                }
                return DataType[value];
            }
        }
    })
    type: DataType;

    @json({
        mapper: {
            from: (values: any[], record: any): any[] => {
                return values?.map((v: any) => ({value: v.value, label: S[v.value]}));
            }
        },
        skip: true
    })
    variants: any[];

    @json({
        skip: true,
        jsonName: 'name',
        mapper: {from: (name: string): string => RELATIONS[name]}
    })
    related: string;

    @json({
        mapper: {
            from: (value: string, record: any) => {
                if (record.type == DataType.TIME_INTERVAL) {
                    return value.split('-');
                } else if (record.type == DataType.PERIOD_FIELD) {
                    return Number(value) * 1000;
                } else if (record.type == DataType.PERIOD_FIELD_WITH_MS) {
                    return Number(value);
                } else if (record.type == DataType.BOOLEAN) {
                    return value === 'true';
                } else if (
                    record.type === DataType.MULTISELECT_LIST ||
                    record.type === DataType.HIDDEN_LIST ||
                    record.name === 'orderItemTypeValues' ||
                    record.name === 'hiddenItemFieldsForDriver' ||
                    record.name === 'mandatoryFieldsForDriverOrderItems'
                ) {
                    return value && value.length ? value.split(',') : [];
                }
                return value;
            },
            to: (value: any, record: any) => {
                if (record.type == DataType.TIME_INTERVAL) {
                    return value.join('-');
                } else if (record.type == DataType.PERIOD_FIELD) {
                    return Number(value) / 1000;
                } else if (record.type == DataType.PERIOD_FIELD_WITH_MS) {
                    return Number(value);
                } else if (record.type === DataType.MULTISELECT_LIST || record.type === DataType.HIDDEN_LIST) {
                    return value.join(',');
                }
                return value;
            }
        }
    })
    value: any;
}
